import React, { Component } from 'react'
import { View, ScrollView, Image, TouchableOpacity, Platform, StyleSheet, Text } from 'react-native';
import { connect } from 'react-redux'
import Header from "../../components/Header";
import { CaptionNormalDark, CaptionBoldDark, SubheaderNormalDark, CircleButton, ProgressBar, ComponentSeeAll, ProfileAvatar } from '../../components';
import DoughnutChart from '../../components/DoughnutChart';
import * as Actions from '../../action';
import styles from '../../styles';
import { global, colors } from '../../const';
import placeholder from '../../assets/placeholder.png'
import EditDarkIcon from '../../assets/icon/edit_ic.png'
import { getRolename } from '../../functions';
import ProfileList from '../../components/profile/ProfileList';
import Button from '../../components/form/Button';
import localize from '../../localize';


class MyprofileContainer extends Component {

    static navigationOptions = () => {
        return {
            title: localize.me
        }
    }

    componentDidMount() {

        if (!this.props.setting.userStrength || this.props.setting.userStrength.length <= 0)
            this.props.currentStrangth()
    }

    _navigate = (pathname, state, search) => {
        if (!global.isNative) {

            return this.props.history.push({
                pathname: '/' + pathname,
                state,
                search
            })
        }
        else {
            return this.props.navigation.navigate(pathname, state);
        }

    };


    render() {
        const { avatar, nickname, role_type } = this.props.userInfo;
        const { height, userStrength } = this.props.setting;
        const { character, life_experience, financial, health, strength } = userStrength;
        let role = getRolename(role_type);

        return (
            <View style={styles.container}>
                {!global.isNative && (<Header title={localize.me} goBack={() => this.props.history.goBack()} />)}
                <ScrollView style={!global.isNative && { height: height - 130 }}>

                    <View style={pageStyles.avatarContainer}>
                        <View style={pageStyles.userAvatar}>
                            <ProfileAvatar
                                src={avatar ? { uri: global.MAKEURL(avatar) } : placeholder}
                                size={"100%"}
                            />
                            <CaptionNormalDark title={role} />
                        </View>
                    </View>

                    <View style={pageStyles.divider} />

                    <View style={pageStyles.profileTitle}>

                        <View style={{ padding: 25 }} />

                        <View style={{ alignItems: 'center' }}>

                            <Text style={pageStyles.smallTitle}>{localize.name}</Text>

                            <Text style={pageStyles.bigTitle}>{nickname}</Text>

                            <TouchableOpacity
                                activeOpacity={0.8}
                                onPress={() => this._navigate('settings')}
                            >
                                <Text style={pageStyles.linkTitle}>{localize.account_settings}</Text>
                            </TouchableOpacity>

                        </View>

                        <CircleButton
                            component={(
                                <Image
                                    source={EditDarkIcon}
                                    style={{ height: 20, width: 20 }}
                                    resizeMode="contain"
                                />
                            )}
                            onPress={() => this._navigate(!global.isNative ? "settings/change-nickname" : 'change_nickname')}
                        />

                    </View>

                    <View style={pageStyles.divider} />

                    {this.props.userTeams && this.props.userTeams.map((item, i) => <ProfileList data={item} type="team" props={this.props} key={i} />)}

                    <View style={pageStyles.rowCenter}>
                        <View style={pageStyles.buttonArea}>
                            <Button
                                title={localize.see_village_leaderboard}
                                size="small"
                                onPress={() => this._navigate(global.isNative ? "VillageLeaderboard" : "profile/village-leader-board")}
                            />
                        </View>
                    </View>
                    <View style={pageStyles.divider} />

                    <View style={pageStyles.progressArea}>

                        <View style={pageStyles.progressHeading}>
                            <SubheaderNormalDark title={localize.strengths} />
                            <ComponentSeeAll
                                onClick={() => this._navigate(Platform.select({ web: "dashboard/progress", default: 'progress' }), { type: 0, id: userStrength.id }, `type=${0}&id=${userStrength.id}`)}
                            />
                        </View>

                        <ProgressBar
                            progress={(strength / 10) + "%"}
                            start={userStrength.maxLevel}
                            end={userStrength.minLevel}
                        />

                    </View>

                    <View style={pageStyles.divider} />

                    <View style={pageStyles.progressChart}>
                        <DoughnutChart
                            data={userStrength}
                            title={localize.team_xp}
                        />
                    </View>

                    <View style={pageStyles.progressChart}>

                        <View style={pageStyles.dontChartRow}>

                            <View style={pageStyles.row}>
                                <View style={[pageStyles.chartColorLable, { backgroundColor: "#00c221" }]} />
                                <CaptionBoldDark title={localize.character} />
                            </View>

                            <CaptionNormalDark title={character} />

                        </View>

                        <View style={pageStyles.dontChartRow}>

                            <View style={pageStyles.row}>
                                <View style={[pageStyles.chartColorLable, { backgroundColor: "#5e23ff" }]} />
                                <CaptionBoldDark title={localize.life_experience} />
                            </View>
                            <CaptionNormalDark title={life_experience} />

                        </View>

                        <View style={pageStyles.dontChartRow}>

                            <View style={pageStyles.row}>
                                <View style={[pageStyles.chartColorLable, { backgroundColor: "#ffd000" }]} />
                                <CaptionBoldDark title={localize.financial} />
                            </View>

                            <CaptionNormalDark title={financial} />

                        </View>

                        <View style={pageStyles.dontChartRow}>

                            <View style={pageStyles.row}>
                                <View style={[pageStyles.chartColorLable, { backgroundColor: "#ff0048" }]} />
                                <CaptionBoldDark title={localize.health_wellness} />
                            </View>

                            <CaptionNormalDark title={health} />
                        </View>
                    </View>

                </ScrollView>
            </View>
        )
    }
}

const mapStateToProps = ({ setting, auth, family }) => {
    return {
        setting: setting,
        userInfo: auth.userInfo,
        userTeams: family.userTeams,
    }
}
const mapDispatch = (dispatch) => {
    return {
        currentStrangth: () => dispatch(Actions.currentStrangth()),
        getUserTeams: dispatch(Actions.getUserOrganization()),
    }
}
export default connect(mapStateToProps, mapDispatch)(MyprofileContainer);

const pageStyles = StyleSheet.create({
    avatarContainer: {
        height: 170,
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 15,
        backgroundColor: colors.white
    },
    userAvatar: {
        width: 130,
        height: 130,
        alignItems: 'center',
        justifyContent: "center"
    },
    divider: {
        height: 1,
        backgroundColor: colors.lightGray,
        width: '100%'
    },
    profileTitle: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: colors.white,
        padding: 10
    },
    smallTitle: {
        color: colors.midnightBack,
        fontSize: 13,
        fontFamily: global.FONT_REGULAR,
    },
    bigTitle: {
        color: colors.midnightBack,
        fontSize: 18,
        fontFamily: global.FONT_REGULAR,
    },
    linkTitle: {
        textDecorationLine: 'underline',
        fontFamily: global.FONT_REGULAR,
        fontWeight: "400",
        fontSize: 13,
        textTransform: 'uppercase',
        color: colors.indigo
    },
    progressArea: {
        backgroundColor: colors.white,
        padding: 20
    },
    progressHeading: {
        paddingBottom: 15,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row'
    },
    progressChart: {
        paddingVertical: 20,
        backgroundColor: colors.white
    },
    dontChartRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 50,
        paddingTop: 15,
        paddingHorizontal: 30
    },
    chartColorLable: {
        height: 12,
        width: 18,
        borderRadius: 4,
        marginRight: 6
    },
    row: {
        alignItems: "center",
        flexDirection: "row"
    },
    buttonArea: {
        width: '60%',
        paddingVertical: 20
    },
    rowCenter: {
        justifyContent: 'center',
        alignItems: 'center',
    },

})